export default __webpack_public_path__ + "static/media/map-pin.ceb65638.svg";